import { getAmendmentsTableColumns } from '../../config/columns';
import AmendmentReasonModal from './AmendmentReasonModal';
import useSortableData from '@/hooks/useSortableData';
import type { Amendment } from '../../models';
import { useMemo, useState } from 'react';
import { Table } from '@/components';

interface AmendmentsTableProps {
  amendments: Amendment[];
  isLoading: boolean;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  shippingBaseUrl?: string;
}

const AmendmentsTable = ({
  amendments,
  isLoading,
  totalItems,
  totalPages,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  shippingBaseUrl,
}: AmendmentsTableProps) => {
  const [selectedReason, setSelectedReason] = useState<string | null>(null);
  const { sortedData, selectedSort, handleSort } = useSortableData({ data: amendments, currentPage });

  const columns = useMemo(
    () => getAmendmentsTableColumns({ onSelectReason: setSelectedReason, shippingBaseUrl }),
    [shippingBaseUrl]
  );

  return (
    <>
      <div className='w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5'>
        {isLoading || amendments.length > 0 ? (
          <div className='overflow-x-auto'>
            <Table
              data={sortedData}
              handleSort={handleSort}
              selectedSort={selectedSort}
              columns={columns}
              isLoading={isLoading}
              pagination={{
                totalItems,
                totalPages,
                currentPage,
                rowsPerPage: pageSize,
                onPageChange,
                onRowsPerPageChange: onPageSizeChange,
                rowsPerPageOptions: [20, 50, 100],
              }}
            />
          </div>
        ) : (
          <div className='text-center py-8'>
            <p className='text-gray-600 text-lg'>No hay enmiendas disponibles</p>
          </div>
        )}
      </div>

      <AmendmentReasonModal
        reason={selectedReason}
        onClose={() => setSelectedReason(null)}
      />
    </>
  );
};

export default AmendmentsTable;
